import React, { useRef, useState, useEffect } from "react";

function Draggable({ gridAreaStyle }) {
  const containerRef = useRef(null); // Reference to the container div
  const [aspectRatio, setAspectRatio] = useState(1); // State to store the aspect ratio

  useEffect(() => {
    const updateAspectRatio = () => {
      if (containerRef.current) {
        const { offsetWidth: width, offsetHeight: height } =
          containerRef.current;
        setAspectRatio(width / height);
      }
    };

    // Observer for resizing
    const resizeObserver = new ResizeObserver(updateAspectRatio);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    // Cleanup observer
    return () => {
      if (containerRef.current) resizeObserver.unobserve(containerRef.current);
    };
  }, []);

  const dragSVG = () => {

    	if(aspectRatio < 0.9 || aspectRatio > 1.1) return null;
      
      return(
        <svg
        id="a"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <rect class="b" x="6" y="6" width="12" height="4" />
        <rect class="b" x="6" y="14" width="12" height="4" />
      </svg>
      )

  }

  return (
    <div
      ref={containerRef}
      className={`draggable ${
        aspectRatio > 1 ? "wide" : aspectRatio < 1 ? "tall" : "square"
      }`}
      draggable="true"
      style={{ gridArea: gridAreaStyle }}
    >
      {dragSVG()}
    </div>
  );
}

export default Draggable;

/*
<svg
        viewBox="0 0 4 4"
        preserveAspectRatio="none"
      >
        <circle cx="2" cy="2" r="2" />
      </svg>
*/
